import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

export default class UploadDialog extends React.Component {
	render(){
		return (
			<Dialog
                open={this.props.open}
                aria-labelledby="alert-dialog-title"
            >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <div style={{textAlign:'center', padding:32}}><CircularProgress/></div>
            </Dialog>
		)
	}
}